import Lenis from 'lenis';

let lenis;

/** Start optional smooth scrolling on the front end only. */
export function initSmoothScroll() {
  if (
    lenis ||
    !document.body.classList.contains('has-smooth-scroll') ||
    document.body.classList.contains('block-editor-page') ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
    return null;

  lenis = new Lenis({
    duration: 1.25,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  });
  const frame = (time) => {
    lenis.raf(time);
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
  return lenis;
}

export function getSmoothScroll() {
  return lenis;
}
